import React from 'react';

const GOLD = '#C9A84C';

export default function CheckoutReturnFailedScreen({ onRetrySubscribe, onDismiss }) {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--bg-primary, #0a0a14)',
      padding: 24,
      fontFamily: "'Inter', -apple-system, sans-serif",
    }}>
      <div style={{
        maxWidth: 440,
        width: '100%',
        background: 'var(--bg-primary, #121212)',
        border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: 20,
        padding: 32,
        textAlign: 'center',
      }}>
        <h2 style={{ fontSize: 22, fontWeight: 700, color: 'var(--text-primary, #fff)', marginBottom: 10 }}>
          Payment not confirmed
        </h2>
        <p style={{ fontSize: 15, color: 'var(--text-secondary, rgba(255,255,255,0.55))', lineHeight: 1.6, marginBottom: 24 }}>
          We couldn&apos;t verify your subscription yet. If you completed checkout, wait a moment and try again — otherwise subscribe to continue.
        </p>
        {onRetrySubscribe && (
        <button
          type="button"
          onClick={onRetrySubscribe}
          style={{
            width: '100%', fontSize: 15, fontWeight: 700, padding: '14px 0', borderRadius: 12,
            background: GOLD, color: '#1a1a2e', cursor: 'pointer', border: 'none', marginBottom: 10,
          }}
        >
          Subscribe again
        </button>
        )}
        {onDismiss && (
          <button
            type="button"
            onClick={onDismiss}
            style={{
              width: '100%', fontSize: 14, fontWeight: 600, padding: '12px 0', borderRadius: 12,
              background: 'transparent', color: 'var(--text-secondary, rgba(255,255,255,0.6))',
              border: 'none', cursor: 'pointer',
            }}
          >
            Continue to Maestro
          </button>
        )}
      </div>
    </div>
  );
}
